import { z } from "zod";
export const VENUS_QUERY_PROBABILITIES_EVENT = "model.query.probabilities";
export const VENUS_QUERY_MAX_TOKENS = 512;
/** Offsets address UTF-8 bytes of the submitted query, never rendered Markdown. */
export const venusQueryProbabilitiesSchema = z.object({
    version: z.literal(1),
    callKey: z.string().min(1),
    model: z.string().min(1),
    source: z.literal("prefill-before-sampling"),
    text: z.string().min(1).max(16_384),
    tokens: z.array(z.object({
        start: z.number().int().nonnegative(),
        end: z.number().int().positive(),
        logprob: z.number().finite().max(0),
    }).strict()).min(1).max(VENUS_QUERY_MAX_TOKENS),
}).strict().superRefine((trace, ctx) => {
    const bytes = new TextEncoder().encode(trace.text);
    let end = 0;
    for (const token of trace.tokens) {
        if (token.start !== end || token.end <= token.start || token.end > bytes.length) {
            ctx.addIssue({ code: "custom", message: "Query token coverage must be contiguous and exact" });
            return;
        }
        end = token.end;
    }
    if (end !== bytes.length)
        ctx.addIssue({ code: "custom", message: "Query token coverage is incomplete" });
});
/** A displayed character may contain several byte-level tokens. Keep all scores. */
export function queryProbabilityTextSegments(trace) {
    const bytes = new TextEncoder().encode(trace.text);
    const decoder = new TextDecoder("utf-8", { fatal: true });
    const result = [];
    let start = 0;
    let logprobs = [];
    for (const token of trace.tokens) {
        logprobs.push(token.logprob);
        // A continuation byte means the token ends inside a Unicode character.
        if (token.end < bytes.length && (bytes[token.end] & 0xc0) === 0x80)
            continue;
        result.push({ text: decoder.decode(bytes.slice(start, token.end)), logprobs });
        start = token.end;
        logprobs = [];
    }
    return result;
}
